import { AdresseFavorite } from "../types/models/adresse-favorite";
import { AdresseFavoriteForm } from "../types/forms/adresse-favorite-form";
import { HttpClient } from "./http-client";

export class AdressesFavoritesService {
  private readonly http: HttpClient;

  constructor(apiUrl: string) {
    this.http = new HttpClient(apiUrl);
  }

  public getFavorites = async (
    idUtilisateur: number,
  ): Promise<AdresseFavorite[]> =>
    this.http.get<AdresseFavorite[]>(
      `/api/utilisateurs/${idUtilisateur}/adresse-favorite`,
    );

  public addFavorite = async (
    idUtilisateur: number,
    adresse: AdresseFavoriteForm,
  ): Promise<void> => {
    await this.http.post(
      `/api/utilisateurs/${idUtilisateur}/adresse-favorite`,
      adresse,
    );
  };

  public deleteFavorite = async (
    idUtilisateur: number,
    idAdresse: number,
  ): Promise<void> => {
    await this.http.delete(
      `/api/utilisateurs/${idUtilisateur}/adresse-favorite/${idAdresse}`,
    );
  };
}
